import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import tw from "tailwind-styled-components";
import Images from "../../Images";
import { Field, Formik, Form } from "formik";
import { useMutation, useQuery } from "react-query";
import Navbar from "../../Components/Navbar";
import axios from "axios";
import Config from "../../Config";
import MenuItem from "@mui/material/MenuItem";

import {
  gDistrictsList,
  gRegionsList,
  gTypeOfRegistration,
  gTypeOfAssociations,
  gTypeOfGame
} from "../../Config";
import {
  Page,
  BoxContainer,
  BoxTitle,
  Underline,
  BoxSubTitle,
} from "../../Components/Styles/PageStyles";
import {
  SubmitBtn,
  PreviewBtn,
  OtherBtn,
  InputGroup,
  FieldWrapper,
  Label,
  FormContainer,
  CombineInputGroup,
} from "../../Components/Styles/InputStyles";
import { useDispatch, useSelector } from "react-redux";
import Loading from "../../Components/Loading";
import moment from "moment";
//import Select from "react-select";
import { HiUpload } from "react-icons/hi";
import { MdAdd, MdKeyboardArrowLeft } from "react-icons/md";
import { toast } from "react-toastify";
import Checkbox from "react-custom-checkbox";
import { BsCheckLg } from "react-icons/bs";
import { Update_User } from "../../Redux/actions";
import DropZone from "../../Components/Applications/DropzoneForSignatures";
import { useTranslation } from "react-i18next";
import Select from "@mui/material/Select";

const EditChangeOfNameForm = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();

  const [openUploadModel, setOpenUploadModel] = useState(false);
  const [openSenderIdModel, setOpenSenderIdModel] = useState(false);
  const [isSendLater, setIsSendLater] = useState(false);
  // const [isAffiliated, setIsAffiliated] = useState(false);
  const [isAffiliated, setIsAffiliated] = useState({ yes: false, no: false });
  const [isRestricted, setIsRestricted] = useState({ yes: false, no: false });
  const [isRegistered, setIsRegistered] = useState({ yes: false, no: false });
  const [isInterested, setIsInterested] = useState({ yes: false, no: false });
  const [game, setGame] = useState("");
  const [gameLabel, setGameLabel] = useState("");
  
  // const [isRestricted, setIsRestricted] = useState(false);
  // const [isRegistered, setIsRegistered] = useState(false);
  // const [isInterested, setIsInterested] = useState(false);
  const [typeOfAssocLabel, setTypeOfAssocLabel] = useState("");
  const [typeOfAssoc, setTypeOfAssoc] = useState("");

  const [typeOfRegLabel, setTypeOfRegLabel] = useState("");
  const [typeOfReg, setTypeOfReg] = useState("");

  const [regionLabel, setRegionLabel] = useState("");
  const [region, setRegion] = useState("");

  const [districtLabel, setDistrictLabel] = useState("");
  const [district, setDistrict] = useState("");
  const [mom, setMom] = useState("");
  const [isSubmitable, setIsSubmitable] = useState(false);

  const [uploadFile, setUploadFile] = useState("");
  const [chairmanSign, setChairmanSignature] = useState("");
  const [secretarySign, setSecretarySignature] = useState("");
  const [assocName, setAssocNameLabel] = useState("");

  //console.log(allDistrictsList);

  const [districtsList, setDistricts] = useState([]);
  const [assocList, setAssociation] = useState([ {
    id: "1",
    name: "Sports Centre",
  }]);

  const user = useSelector((state) => state?.UserReducer?.user);


  const [isInitialValueSaved, setIsInitialValueSaved] = useState(true);
  const [previewOpenModel, setPreviewOpenModel] = useState(false);


  const [isBasicFormOpen, setIsBasicFormOpen] = useState(true);
  const [isReportDetailsOpen, setIsReportDetailsOpen] = useState(true);

  const { id } = useParams();

  const toggleBasicFormOpen = () => setIsBasicFormOpen(!isBasicFormOpen);

  const toggleReportDetailsOpen = () =>
    setIsReportDetailsOpen(!isReportDetailsOpen);
    
  // -------------  Initial Data -------------
  const fetchFunction = async () => {
    const body = new FormData();
    body.append("id", id);
    body.append("userType", user.userType);
    body.append("serviceType", 3);
    return await axios.post(`${Config.apiUrl}/mysingleapplication`, body, {
      headers: {
        authorization: user.token,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    }); 
  }

  const {
    data,
    error,
    isLoading: InitialLoading,
  } = useQuery(`getSenderIdContactGroups`, fetchFunction);


  const InitialValue = {
    id: data?.data?.data[0]?.id || "",
    assocName:data?.data?.data[0]?.assocName  || "",
    newName: data?.data?.data[0]?.newName  || "",
    reason: data?.data?.data[0]?.reason  || "",
    dated: data?.data?.data[0]?.dated  || "",
    mom: data?.data?.data[0]?.mom || "",

  };

  useEffect(()=>{
    // setTypeOfReg (data?.data?.data?.typeOfReg);
    // setTypeOfRegLabel (data?.data?.data?.typeOfRegLabel);
    // setTypeOfAssocLabel (data?.data?.data?.typeOfAssocLabel);
    // setRegionLabel (data?.data?.data?.regionLabel);
    // setDistrictLabel (data?.data?.data?.districtLabel);
    // SetDynamicAssociation (data?.data?.data?.typeOfReg);
    // SetDynamicDistricts (data?.data?.data?.region);
    // setIsInitialValueSaved (false);
    // setGameLabel(data?.data?.data?.gameLabel);
  },[data])
  //setTypeOfReg (data?.data?.data?.typeOfReg);
  //setTypeOfRegLabel (data?.data?.data?.typeOfRegLabel);


  // -------------   Run Campaign  -------------
  const postFunction = async (values) => {
    return await axios.post(`${Config.apiUrl}/editchangename`, values, {
      headers: {
        authorization: user.token,
        "Content-type": "multipart/form-data",
      },
    });
  };

  const onSuccess = (res) => {
    if (res?.data?.status == "OK") {
      toast.success(res?.data?.msg || "Success");
      navigate("/my-applications");
    } else toast.error(res?.data?.msg || "Error");
  };

  const onError = (err) => {
    toast.error(err?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: isLoading, mutate: nameChangeMutate } = useMutation(
    postFunction,
    {
      onSuccess: onSuccess,
      onError: onError,
    }
  );

  
  
  const SubmitHandler = (values) => {
      const body = new FormData();
      body.append("id", values.id);
      body.append("email", user.email);
      body.append("customerId", user.id);
      body.append("assocId", values.assocId);
      body.append("assocName", assocName);
      body.append("newName", values.newName);
      body.append("reason", values.reason);
      body.append("dated", values.dated);
      body.append("mom", mom);
      body.append("chairmanSign", chairmanSign);
      body.append("secretarySign", secretarySign);
      nameChangeMutate(body);
      
  };

  const RegistrationList = gTypeOfRegistration.map((item) => ({
    value: item.id,
    label: item.name,
  }));

  const AssociationList = assocList.map((item) => ({
    id: item.id,
    name: item.name,
  }));


  const RegionList = gRegionsList.map((item) => ({
    id: item.id,
    name: item.name,
  }));

  const SetDynamicDistricts = (value) => {
    if (value == null)
      value = 1;
    setDistricts(gDistrictsList[value]);
  };

  const SetDynamicAssociation = (value) => {
    //console.log(value);
    if (value == null)
      value = 1;
    setAssociation(gTypeOfAssociations[value]);
  };

  const DistrictList = districtsList.map((item) => ({
    id: item.id,
    name: item.name,
  }));

  
  return (
    <>
      <Navbar />
      <Page>
        <BoxContainer>
          <BoxTitle onClick={() => navigate(-1)}>
            {/* <MdKeyboardArrowLeft className="text-gray-700 w-6 h-6" /> */}
            <p>{t('APPLICATION_ASSOCIATION')}</p>
          </BoxTitle>
          <Underline />
          <BoxSubTitle>{t('Application_Association')}</BoxSubTitle>

          <Formik
            initialValues={InitialValue}
            onSubmit={SubmitHandler}
            enableReinitialize={isInitialValueSaved}
          >
            {(formikProps) => (
              <>
                <Form>
                  <FormContainer className="md:mt-8">
                     
                      <>
                      {/* <InputGroup>
                          <Label htmlFor="name">Association Name</Label>
                          <FieldWrapper $select={true}>
                              <Field
                                required
                                name="name"
                                id="name"
                                autoComplete="off"
                              >
                                {(props) => (

                                <Select
                                {...props.field}
                                  className="w-full h-full pl-2 bg-transparent text-sm p-0  border-none"
                                  onChange={(e) => {
                                    const selectedItem = user.associations.find(item => item.id == e.target.value);
                                    console.log(selectedItem.assocName)
                                    setAssocNameLabel (selectedItem.assocName);
                                    // SetDynamicAssociation(e.target.value);
                                    props.form.setFieldValue(
                                      "assocId",
                                      e.target.value
                                    );
                                   
                                  }}
                                >
                                  {user.associations.map(item=>(
                                      <MenuItem value={item.id}>{item.assocName}</MenuItem>
                                  ))}
                                  
                                </Select>
                                )}
                              </Field>
                          </FieldWrapper>
                        </InputGroup> */}

                        
                        <InputGroup>
                          <Label htmlFor="newName">
                          {t('New_Association')} 
                          </Label>
                          <FieldWrapper>
                            <Field
                              name="newName"
                              id="newName"
                              autoComplete="off"
                            />
                          </FieldWrapper>
                        </InputGroup>

                        {/* <InputGroup>
                          <Label htmlFor="postal">
                            Portal Address Of Association
                          </Label>
                          <FieldWrapper>
                            <Field
                              name="postal"
                              id="postal"
                              autoComplete="off"
                            />
                          </FieldWrapper>
                        </InputGroup> */}

                        <InputGroup>
                          <Label htmlFor="reason">
                          {t('Change_desire')}
                          </Label>
                          <FieldWrapper>
                            <Field
                              name="reason"
                              as="textarea"
                              rows="6"
                              id="reason"
                              placeholder="Type your Reason here"
                              autoComplete="off"
                            />
                          </FieldWrapper>
                        </InputGroup>
                        <InputGroup>
                          <Label htmlFor="dated">
                           {t('Dated')}
                          </Label>
                          <FieldWrapper>
                            <Field
                              name="dated"
                              id="dated"
                              autoComplete="off"
                              type="date"
                            />
                          </FieldWrapper>
                        </InputGroup>
                        <InputGroup>
                          <Label htmlFor="mom">
                           {t('mom')}
                          </Label>
                          <DropZone setUploadFile={setMom} />
                        </InputGroup>
                        <InputGroup>
                          <Label htmlFor="chairmanSign">
                            {t('Chairman')}
                          </Label>
                          <DropZone setUploadFile={setChairmanSignature} />
                        </InputGroup>
                        <InputGroup>
                          <Label htmlFor="secretarySign">
                          {t('Secretary')}
                          </Label>
                          <DropZone setUploadFile={setSecretarySignature} />
                        </InputGroup>

                      </>
                  </FormContainer>
              <div className="mt-14">
                  <SubmitBtn type="submit" disabled={isLoading}>
                          {isLoading && (
                            <Loading
                              color="white"
                              width={20}
                              height={20}
                              noPadding={true}
                            />
                          )}
                          {!isLoading && t('Update')}
                        </SubmitBtn>
                  </div>
                </Form>
              </>
            )}
          </Formik>
        </BoxContainer>
      </Page>
    </>
  );
};

const Button = tw.button`text-white bg-teal-500 hover:bg-teal-600 w-52 flex items-center space-x-1 justify-center h-10   text-xs whitespace-nowrap rounded`;

const LabelCheckboxWrapper = tw.div``;
const CheckboxWrapper = tw.div`flex items-center space-x-5 mt-2.5`;


export default EditChangeOfNameForm;
